export enum DELIVERY_METHODS {
	home_delivery = 'home_delivery',
	store_delivery = 'store_delivery',
	droppoint_delivery = 'droppoint_delivery',
	not_found_delivery = 'not_found_delivery',
}
